/**
 * Principal risk LP API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Account } from './account';

/**
 * Account pair specific settings Dto.
 */
export interface PrincipalRiskAccountPairSettingsDto {
  id: number;
  lpPairId: number;
  account: Account;
  /**
   * Formula: 1 = 0.1 BPS = 0.001% = 0.00001.
   */
  takeProfit: number;
  /**
   * Formula: 1 = 0.1 BPS = 0.001% = 0.00001.
   */
  stopLoss: number;
  /**
   * In milliseconds
   */
  maxRiskTime: number;
  minExecVolume: number;
  maxExecVolume: number;
}
